import styled from 'styled-components'

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .2rem;
`

export const ContainerInfo = styled.span`
  display: flex;
  flex-direction: row;
  gap: .3rem;
  justify-content: start;

`

export const TextDescription = styled.span`
  font-size: 15px;
`

export const Text = styled(TextDescription)`
  font-weight: bold;
`
